module.exports = __webpack_public_path__ + "img/vip2.c23b3e46.jpg";